var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlanInformationShareReferralIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 79,
    viewBox: "0 0 80 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.125 69.6117C43.125 69.6117 44.125 69.2447 45 68.633L74.875 45.1437C76.75 43.6756 77.875 41.4734 77.875 39.149C77.875 36.8245 76.75 34.6224 74.875 33.1543L45 9.66492C43.625 8.56386 41.75 8.44152 40.25 9.17556C38.625 9.9096 37.75 11.5 37.75 13.2128V25.6915C27.625 27.2819 18.375 31.6862 11.375 38.4149C6.5 43.3085 4.125 47.8351 2.75 54.6862C2.5 56.1543 2.25 58.8458 2.25 62.3936C2.25 63.9841 3.125 65.5745 4.625 66.3085C6.125 67.0426 7.875 67.0426 9.25 66.1862C19.75 59.5798 29.5 55.5426 37.75 54.3192V65.3298C37.75 67.0426 38.75 68.5107 40.25 69.3671C40.875 69.4894 41.5 69.6117 42.125 69.6117ZM43.25 15.4149L71.25 37.4362C72.125 37.9256 72.25 38.7819 72.25 39.149C72.25 39.516 72.125 40.25 71.375 40.8617L43.375 62.883V51.1383C43.375 50.4043 43 49.6702 42.5 49.1809C41.875 48.6915 41.125 48.3245 40.375 48.4468C28.75 49.1809 16.625 55.0532 7.875 60.4362C8 57.6224 8.125 56.2766 8.25 55.7873C9.375 50.0373 11.25 46.4894 15.375 42.3298C22 35.9681 31 31.8085 40.875 30.8298C42.25 30.7075 43.375 29.4841 43.375 28.1383V15.4149H43.25Z",
    fill: "#284993"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanInformationShareReferralIcon);
export default __webpack_public_path__ + "static/media/plan-information-share-referral-icon.7d4125eb1bd38365e7b0f86f0307a849.svg";
export { ForwardRef as ReactComponent };